import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SessionService } from 'src/app/services/shared/session/session.service';

@Component({
    selector: 'app-session-dialog',
    templateUrl: './session-dialog.component.html',
    standalone: false
})
export class SessionDialogComponent implements OnInit {

  minutes: number = 3;
  seconds: number = 0;
  secondsText: string = '00';
  private intervalId: any;
  constructor(
    private sessionService: SessionService,
    public dialogRef: MatDialogRef<SessionDialogComponent>
  ) { }

  ngOnInit(): void {
    console.log('[Session Debug] SessionDialog ngOnInit. dialogId:', this.dialogRef.id, '| timer inicial:', `${this.minutes}:${this.secondsText}`);
    this.intervalId = setInterval(() => {
      if (this.seconds === 0) {
        if (this.minutes === 0) {
          console.log('[Session Debug] SessionDialog countdown agotado. Ejecutando handleLogout(). dialogId:', this.dialogRef.id);
          this.sessionService.handleLogout();
          clearInterval(this.intervalId);
          return;
        } else {
          this.minutes--;
          this.seconds = 59;
          this.secondsText = String(this.seconds);
        }
      } else {
        this.seconds--;
        this.secondsText = String(this.seconds).padStart(2, '0');
      }
    }, 1000)
  }

  // value 0: Cerrar sesión
  // value 1: Continuar sesión
  handleSession(value: number): void {
    console.log('[Session Debug] SessionDialog handleSession(). value:', value, '| dialogId:', this.dialogRef.id);
    clearInterval(this.intervalId);
    this.minutes = 3;
    this.dialogRef.close(value);
  }

}
